import * as actionTypes from './actionTypes';
import { Auth, API } from 'aws-amplify';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

export const setViewPerm = (user) => {
    return async dispatch => {
        const user_views = await API.get('user_assets','/' + user, params)
        const perms = await API.get('permissions','/types', params)
        const entries = Object.entries(perms.values)

        let profile = 'General'
        if (user_views.settings){
            localStorage.setItem('formatDate', JSON.stringify(user_views.settings.format_date));
            profile = user_views.settings.profile
        }
        if (profile == ''){
            profile = 'General'
        }
        console.log({profile})


        const permission = await API.get('custom_permission_list','/', params)

        let ls = []
        for (let i = 0; i < permission.length; i++) {
            const { profile_name, ...newObj } = permission[i].customProfile;
            
            if (profile_name == profile){
                ls.push([permission[i].customProfile.profile_name, newObj])
            }
        }

        let perm = entries.find(i => i[0]===profile)
        // if (perm)
        //     perm = perm[1];
        if (ls[0])
            perm = ls[0][1];
        const permList = []
        Object.keys(perm).map((key,i) =>
            Object.keys(perm[key]).map((key1,j) =>{
                if (perm[key][key1].checked)
                    permList.push(key1)
                return (permList)
            })
        )
        // localStorage.setItem('perm', JSON.stringify(user_views.views));
        localStorage.setItem('perm', JSON.stringify(permList));

        dispatch({
            type: actionTypes.SET_PERMISSIONS,
            viewPermissions: permList || [],
            formatDate: user_views.settings.format_date || 'DD-MM-YYYY'
        })
    }
}

export const getViewPerm = () => {
    return {
            type: actionTypes.GET_PERMISSIONS,
            viewPermissions:  JSON.parse(localStorage.getItem('perm')) || [],
            formatDate: JSON.parse(localStorage.getItem('formatDate'))  || 'DD-MM-YYYY'
        }
}

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authStartChecking = () => {
    return {
        type: actionTypes.AUTH_START_CHECKING
    };
};

export const checkFail = () => {
    return {
        type: actionTypes.AUTH_CHECK_FAIL
    };
};

export const authSuccess = (token, user,userFullname) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        user: user,
        userFullname: userFullname,
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    Auth.signOut();
    localStorage.clear();
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};


export const auth = (email, password) => {
    return dispatch => {
        dispatch(authStart());
        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        };

        Auth.signIn(authData.email, authData.password)
            .then(response =>{
                localStorage.setItem('user', response.username);
                // check access
                dispatch(authSuccess(
                        true,
                        {'username': response.username,
                        'name': response.signInUserSession.idToken.payload.name,
                        'contractor': response.signInUserSession.idToken.payload["custom:contractor"],
                        'administrator': response.signInUserSession.idToken.payload["custom:administrator"]},
                        response.signInUserSession.idToken.payload.name
                        ));

                }).catch(error => {
                dispatch(authFail(error.message));
            })
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        dispatch(authStartChecking());
        Auth.currentSession()
            .then(async response => {
                localStorage.setItem('user', response.idToken.payload["cognito:username"]);
                // check user profile
                const user_settings = await API.get('user_assets','/' + response.idToken.payload["cognito:username"], params)
                let profile = 'General'
                let user_assets = []
                if (user_settings.settings) profile = user_settings.settings.profile
                if (user_settings.assets) user_assets = user_settings.assets
                              
                // check access
                dispatch(authSuccess(
                    true,
                    {'username': response.idToken.payload["cognito:username"],
                    'name': response.idToken.payload.name,
                    'contractor': response.idToken.payload["custom:contractor"],
                    'administrator': response.idToken.payload["custom:administrator"],
                    'profile': profile,
                    'user_assets': user_assets },
                    response.idToken.payload.name
                    ));
                dispatch(setViewPerm(response.idToken.payload["cognito:username"]));

            })
            .catch(err =>{
                console.log("Auth: " + err)
                dispatch(checkFail());
                dispatch(logout());

            });

        // }
    };
};


